<div class="flex w-full flex-col items-center gap-4 p-8" [ngClass]="containerClassName">
  @if (badge) {
    <span class="mb-1 rounded-sm border border-border bg-gray-100 px-2.5 py-1 text-sm">{{ badge }}</span>
  }
  <h4 class="max-w-[800px] text-center text-4xl">{{ title }}</h4>
  <span class="max-w-[600px] text-center text-lg text-secondary-foreground" [ngClass]="className"> {{ description }} </span>
</div>
